export default __webpack_public_path__ + "static/media/fresh.352403e1.png";